export default __webpack_public_path__ + "static/island-life-desktop-7e447da0c92bd173ab50381b5f670cb8.webp";